

import { FlagModel, INumberModel, NumberModel } from '@zajno/common-mobx/viewModels';
import { ILogger } from '@zajno/common/logger';
import { IValueModelReadonly } from '@zajno/common/models/types';
import { gsap } from 'gsap';
import { reaction } from 'mobx';

export function createThreeAnimationBridge() {
    return {
        isActive: new FlagModel(),
        progress: new NumberModel(),
        isExternalInitialized: new FlagModel(false),
    };
}

export type BridgeBase = ReturnType<typeof createThreeAnimationBridge>;

type ProgressTimelineOptions = {
    vars?: gsap.TweenVars;
    logger?: ILogger;
    referenceStTimeline?: gsap.core.Timeline | false;
};

export function createProgressTimeline(progress: INumberModel, options?: ProgressTimelineOptions) {
    const { logger, vars, referenceStTimeline } = options || { };
    if (logger) {
        reaction(
            () => Math.round(progress.value * 100) / 100,
            (v) => logger.log('progress', v),
            { fireImmediately: true },
        );
    }

    const proxy = { progress: 0 };
    const tl = gsap.timeline({ defaults: { ease: 'none' } });

    const checkStTimeline = referenceStTimeline !== false;
    const stTimeline = referenceStTimeline || tl;

    tl.fromTo(
        proxy,
        { progress: 0 },
        {
            ...vars,
            progress: 1,
            onUpdate: () => {
                if (checkStTimeline && !stTimeline.scrollTrigger?.isActive) {
                    return;
                }
                progress.value = proxy.progress;
            },
        },
    );
    return tl;
}

export function hookOnProgress(tl: gsap.core.Timeline, model: IValueModelReadonly<number>, cb?: (progress: number) => void) {
    tl.paused(true);
    const ccb = cb || (() => { /* no-op */ });
    return reaction(
        () => model.value,
        (progress) => {
            const pp = progress;
            tl.progress(pp);
            ccb(pp);
        },
        { fireImmediately: true },
    );
}
